import { useAtom, useAtomValue } from 'jotai';
import { apiFilterAtom, filterStateAtom, isFilterAppliedAtom } from './state';

export const useProductFilter = () => {
    const [state, setState] = useAtom(filterStateAtom);
    const isApplied = useAtomValue(isFilterAppliedAtom);
    return [state, setState, isApplied] as const;
};

export const useProductApiFilter = () => useAtomValue(apiFilterAtom);
